"use strict";

// M1-1467: In trying to update server dependencies, npm was being an asshole and preventing
// things from working (even with the --force flag). One of the problems related to recompose
// v0.17, even though we were on v0.30.0, which is the latest.
// Anyways, recompose is on the way out because we're slowly replacing class components with
// functional components... and recompose has been essentially obsoleted by React hooks.
// We are only using the `compose` method from recompose... so I've just copied the source
// code here directly and uninstall recompose.

export function compose() {
    for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
        funcs[_key] = arguments[_key];
    }

    return funcs.reduce(function (a, b) {
        return function () {
            return a(b.apply(void 0, arguments));
        };
    }, function (arg) {
        return arg;
    });
};
